import Paragraph from "@tiptap/extension-paragraph";
export default Paragraph.extend({
  addAttributes() {
    return {
      padding: {
        default: '0.1px',
        renderHTML: attributes => {
          return {
            style: `padding: ${attributes.padding}`
          };
        }
      }
      /*            textAlign: {
                      default: 'start',
                      renderHTML: attributes => {
                          return {
                              style: `text-align: ${attributes.textAlign}`,
                          }
                      }
                  }*/
      // textDirection: {
      //     default: 'auto',
      //     renderHTML: attributes => {
      //         return {
      //             style: `direction: ${attributes.textDirection}`,
      //         }
      //     },
      // }
    };
  }
});